module.exports = __webpack_public_path__ + "img/tracey-rose-peyton.e0901810.png";